import { render, staticRenderFns } from "./freeTournament.vue?vue&type=template&id=60d65b5d&"
import script from "./freeTournament.vue?vue&type=script&lang=js&"
export * from "./freeTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports